import { render } from "./Notifiche24Giorni.vue?vue&type=template&id=4dc38a1e"
import script from "./Notifiche24Giorni.vue?vue&type=script&lang=js"
export * from "./Notifiche24Giorni.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__